import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';
import { apiLucree, apiPGM } from '../services/api';
// import TipoFilial from '../assets/styles/payloadsFilial/payloadFilial.json';

export const FilialContext = createContext([]);

export function FilialProvider(props) {
	const { children, user } = props;

	const [dataFiliais, setDataFiliais] = useState([]);
	const [totalFilial, setTotalFilial] = useState(0);
	const [montante, setMontante] = useState('');
	const [loadingFilial, setLoadingFilial] = useState(true);

	async function authToken() {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}
		return null;
	}

	async function getFiliais(pagina = 1) {
		try {
			setLoadingFilial(false)
			const response = await apiPGM.get(`/resumo/filiais`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: {page: pagina}
				}).then(res => {
					setLoadingFilial(true)
					setMontante(res.data.montante)
					setDataFiliais(res.data.dados)
					setTotalFilial(res.data.total_registros)
				});

			return response;
		} catch (error) {
			setLoadingFilial(true)
			toast.error(
				'Filiais não carregadas. Por favor atualize a página.'
			);
		}
		return null;
	}

	return (
		<FilialContext.Provider
			value={{
				authToken,
				getFiliais,
				dataFiliais,
				montante,
				totalFilial,
				loadingFilial,
				// getExport
			}}>
			{children}
		</FilialContext.Provider>
	);
}
